var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H2.625C1.18125 0 0 1.17 0 2.6V23.4C0 24.83 1.18125 26 2.625 26H18.375C19.8188 26 21 24.83 21 23.4V2.6C21 1.17 19.8188 0 18.375 0ZM2.625 2.6H9.1875V13L5.90625 11.05L2.625 13V2.6Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon_book.459f6d1753ad001978472d2910507742.svg";
export { ForwardRef as ReactComponent };